<template>
  <footer id="contact" class="pt-16 pb-8 bg-slate-900 text-slate-300">
    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 gap-12 mb-12 md:grid-cols-2 lg:grid-cols-3">
        <!-- Brand -->
        <div class="space-y-6">
          <div class="relative h-10">
            <img
              :src="
                $store.getters.getImageUrl(
                  $store.getters.getThemeColumn('footer_logo')
                )
              "
              :alt="$store.getters.getThemeColumn('company_name')"
              class="block h-full"
            />
          </div>
          <p class="leading-relaxed text-slate-400">
            仁曜診所致力於提供溫暖、專業的家庭醫學照護。我們是您社區中最值得信賴的健康夥伴。
          </p>
          <div class="flex space-x-4">
            <a
              :href="$store.getters.getThemeColumn('company_facebook')"
              target="_blank"
              class="transition-colors hover:text-brand-orange"
              ><i data-lucide="facebook" class="w-6 h-6"></i
            ></a>
            <a
              :href="$store.getters.getThemeColumn('company_instagram')"
              target="_blank"
              class="transition-colors hover:text-brand-orange"
              ><i data-lucide="instagram" class="w-6 h-6"></i
            ></a>
            <a
              :href="$store.getters.getThemeColumn('company_line')"
              target="_blank"
              class="transition-colors hover:text-brand-orange"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="w-6 h-6"
                fill="currentColor"
                height="800px"
                width="800px"
                version="1.1"
                id="Capa_1"
                viewBox="0 0 296.528 296.528"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M295.838,115.347l0.003-0.001l-0.092-0.76c-0.001-0.013-0.002-0.023-0.004-0.036c-0.001-0.011-0.002-0.021-0.004-0.032   l-0.344-2.858c-0.069-0.574-0.148-1.228-0.238-1.974l-0.072-0.594l-0.147,0.018c-3.617-20.571-13.553-40.093-28.942-56.762   c-15.317-16.589-35.217-29.687-57.548-37.878c-19.133-7.018-39.434-10.577-60.337-10.577c-28.22,0-55.627,6.637-79.257,19.193   C23.289,47.297-3.585,91.799,0.387,136.461c2.056,23.111,11.11,45.11,26.184,63.621c14.188,17.423,33.381,31.483,55.503,40.66   c13.602,5.642,27.051,8.301,41.291,11.116l1.667,0.33c3.921,0.776,4.975,1.842,5.247,2.264c0.503,0.784,0.24,2.329,0.038,3.18   c-0.186,0.785-0.378,1.568-0.57,2.352c-1.529,6.235-3.11,12.683-1.868,19.792c1.428,8.172,6.531,12.859,14.001,12.86   c0.001,0,0.001,0,0.002,0c8.035,0,17.18-5.39,23.231-8.956l0.808-0.475c14.436-8.478,28.036-18.041,38.271-25.425   c22.397-16.159,47.783-34.475,66.815-58.17C290.172,175.745,299.2,145.078,295.838,115.347z M92.343,160.561H66.761   c-3.866,0-7-3.134-7-7V99.865c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7v46.696h18.581c3.866,0,7,3.134,7,7   C99.343,157.427,96.209,160.561,92.343,160.561z M119.03,153.371c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V99.675   c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7V153.371z M182.304,153.371c0,3.033-1.953,5.721-4.838,6.658   c-0.712,0.231-1.441,0.343-2.161,0.343c-2.199,0-4.323-1.039-5.666-2.888l-25.207-34.717v30.605c0,3.866-3.134,7-7,7   c-3.866,0-7-3.134-7-7v-52.16c0-3.033,1.953-5.721,4.838-6.658c2.886-0.936,6.045,0.09,7.827,2.545l25.207,34.717V99.675   c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7V153.371z M233.311,159.269h-34.645c-3.866,0-7-3.134-7-7v-26.847V98.573   c0-3.866,3.134-7,7-7h33.57c3.866,0,7,3.134,7,7s-3.134,7-7,7h-26.57v12.849h21.562c3.866,0,7,3.134,7,7c0,3.866-3.134,7-7,7   h-21.562v12.847h27.645c3.866,0,7,3.134,7,7S237.177,159.269,233.311,159.269z"
                  />
                </g>
              </svg>
            </a>
          </div>
        </div>

        <!-- Contact -->
        <div>
          <h3
            class="pl-3 mb-6 text-lg font-bold text-white border-l-4 border-brand-orange"
          >
            聯絡資訊
          </h3>
          <ul class="space-y-4">
            <li class="flex items-start gap-3">
              <i
                data-lucide="map-pin"
                class="w-5 h-5 mt-1 text-brand-blue shrink-0"
              ></i>
              <span>
                {{ $store.getters.getThemeColumn("company_address") }}
              </span>
            </li>
            <li class="flex items-center gap-3">
              <i
                data-lucide="phone"
                class="w-5 h-5 text-brand-blue shrink-0"
              ></i>
              <a
                :href="'tel:' + $store.getters.getThemeColumn('company_phone')"
                class="transition-colors hover:text-white"
              >
                {{ $store.getters.getThemeColumn("company_phone") }}</a
              >
            </li>
          </ul>
        </div>

        <!-- Hours -->
        <div>
          <h3
            class="pl-3 mb-6 text-lg font-bold text-white border-l-4 border-brand-orange"
          >
            門診時間
          </h3>
          <ul class="space-y-3 text-sm">
            <li class="flex justify-between pb-2 border-b border-slate-700">
              <span>週一、三、四</span>
              <span class="text-white">早診 / 午診 / 晚診</span>
            </li>
            <li class="flex justify-between pb-2 border-b border-slate-700">
              <span>週五、六、日</span>
              <span class="text-white">早診 / 午診</span>
            </li>
            <li class="flex justify-between pb-2 font-bold text-brand-orange">
              <span>週二</span>
              <span>全日休診</span>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="pt-8 text-sm text-center border-t border-slate-800 text-slate-500"
      >
        <p>
          &copy; <span id="year"></span> 仁曜診所 Renyao Clinic. All rights
          reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
  mounted() {
    const yearSpan = document.getElementById("year");
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear();
    }
  },
};
</script>
